import { memo } from 'react';
// @mui
import { BoxProps } from '@mui/material/Box';
import Iconify from 'src/components/iconify/iconify';

// ----------------------------------------------------------------------

function NavPremiumIcon({ width }: BoxProps) {
  return (
    <Iconify
      width={width}
      icon="eva:star-outline"
      sx={{
        ml: 1,
        flexShrink: 0,
        color: '#ffbd1b',
        borderColor: '#ffbd1b',
      }}
    />
  );
}

export default memo(NavPremiumIcon);
